module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/messages.component.css
// module id = ./src/app/messages/messages.component.css
// module chunks = main